<template>
  <el-row :gutter="10" type="flex" justify="center">
    <el-col :lg="8" :md="12" :sm="24">
      <el-card class="login-form-container">
        <h3>Gửi lại Email kích hoạt</h3>
        <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
        <el-form ref="form" :model="form" :rules="rules" :hide-required-asterisk="true" @keyup.enter.native="onSubmit">
          <div style="margin-top: 32px">
            <el-form-item prop="email" class="el-col-18" style="padding-right: 2px">
              <el-input v-model="form.email" placeholder="Email" />
            </el-form-item>

            <el-form-item class="el-col-6" style="padding-left: 2px">
              <CommonButton :ref="refs.SUBMIT_BUTTON" type="primary" @click="onSubmit">Gửi</CommonButton>
            </el-form-item>

            <el-row justify="space-between" class="el-col-24">
              <router-link :to="Paths.LOGIN">Đăng nhập</router-link>
              &nbsp;
              <router-link :to="Paths.REGISTER">Đăng ký</router-link>
            </el-row>
          </div>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { resendConfirmRegistration } from '../services/authentication_service'
import { Paths } from '@/routes/paths.js'
import CommonButton from '@/components/common/CommonButton.vue'

export default {
  name: 'ResendConfirmRegistration',
  components: { CommonButton },
  data() {
    return {
      form: {
        email: '',
      },
      isRequesting: false,
      rules: {
        email: [
          { required: true, message: 'Hãy nhập email đăng ký', trigger: 'change' },
          { type: 'email', message: 'Hãy nhập chính xác địa chỉ email', trigger: 'blur' },
        ],
      },
      errorMessage: null,
      Paths,
      refs: {
        SUBMIT_BUTTON: 'SUBMIT_BUTTON',
      },
    }
  },
  methods: {
    onSubmit() {
      this.errorMessage = null
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$refs[this.refs.SUBMIT_BUTTON].setLoading(true)
          resendConfirmRegistration(this.form.email, this.onSuccess, this.onError, () => {
            this.$refs[this.refs.SUBMIT_BUTTON].setLoading(false)
          })
        } else {
          return false
        }
      })
    },
    onSuccess() {
      this.$message({
        message: 'Đường dẫn xác nhận sẽ được gửi đến email của bạn trong giây lát',
        type: 'success',
      })
    },
    onError(message) {
      this.errorMessage = message
      this.$message.error(message)
    },
    gotoLogin() {
      this.$router.push(Paths.LOGIN)
    },
  },
}
</script>

<style scoped>
.login-form-container {
  padding: 1em;
}

.error-message {
  margin-top: 2px;
  padding: 5px 5px 5px 10px;
  background-color: indianred;
  width: 100%;
  border-radius: 3px;
  color: white;
}
</style>
